module.exports = __webpack_public_path__ + "8a85463ffe3c3b02c6bf7283e3a81804.svg";